import { useState } from "react";
import { useLocale } from "@aviv-unified-frontend/runtime/i18n";
import { sendLead, buildSendMailActionParams } from "@/utils";
import { useSendLeadTracking, useCustomerAction } from "@/hooks";
import { useAuthContext } from "@/contexts/auth";
import { useConfig, useCrsBaseUrl } from "@/contexts/cdpConfig";
import { useContactBrand, useCdpId } from "@/contexts/contact";
import { useConfirmationPage } from "@/contexts/confirmPage";
import { useTrackingLegacyLeadEvents } from "@/hooks/tracking/trackingLegacy";
import { useContactContext } from "@/contexts/contact";
import { useClassified, useLegacyId } from "@/contexts/classified";
import { useClassifiedAnalytics } from "@/hooks/tracking/classifiedAnalytics";
import { CA_EVENT_TYPES } from "@/types/classifiedAnalytics";
export const useSendLead = () => {
    var _a, _b;
    const { language } = useLocale();
    const [loading, setLoading] = useState(false);
    const [postLeadError, setPostLeadError] = useState(false);
    const cdpLegcyId = useLegacyId();
    const classifiedId = useCdpId();
    const brand = useContactBrand();
    const { validToken } = useAuthContext();
    const { customerActionExposeContact } = useCustomerAction();
    const { triggerConfirmView } = useConfirmationPage();
    const { sendClassifiedAnalyticsEvent } = useClassifiedAnalytics();
    const baseUrl = useCrsBaseUrl();
    const sendLeadUrl = `${baseUrl}/contacting`;
    const featuresFlags = (_a = useConfig()) === null || _a === void 0 ? void 0 : _a.featuresFlags;
    const { legacyLeadConversionMail, legacyLeadConfirmationMail } = useTrackingLegacyLeadEvents(); //legacy GA3 for harvest
    const legacyTrackingData = (_b = useClassified()) === null || _b === void 0 ? void 0 : _b.legacyTracking;
    const hasLegacyTrackingData = !!legacyTrackingData;
    const { leadFormOk, leadFormConfirm, getAdditionalProps } = useSendLeadTracking();
    const { contactTracking } = useContactContext();
    const handleSubmit = async (data, av_zone) => {
        const trackingProps = getAdditionalProps(data, av_zone);
        if (hasLegacyTrackingData) {
            legacyLeadConversionMail({
                eventData: {
                    infos: contactTracking === null || contactTracking === void 0 ? void 0 : contactTracking.trackingLegacyInfos,
                    email_lead: data === null || data === void 0 ? void 0 : data.email,
                },
            }); //legacy GA3 for harvest
        }
        leadFormOk(trackingProps);
        const sendLeadDatas = {
            ...data,
            language,
            classifiedId: contactTracking.unitId || classifiedId,
            gokId: cdpLegcyId,
            brand,
            featuresFlags,
        };
        try {
            setLoading(true);
            const response = await sendLead(sendLeadUrl, sendLeadDatas, validToken);
            if (response.status !== 200) {
                throw new Error("Error sending lead");
            }
            leadFormConfirm(trackingProps);
            if (hasLegacyTrackingData) {
                legacyLeadConfirmationMail({
                    eventData: {
                        infos: contactTracking === null || contactTracking === void 0 ? void 0 : contactTracking.trackingLegacyInfos,
                        email_lead: data === null || data === void 0 ? void 0 : data.email,
                    },
                });
            }
            sendClassifiedAnalyticsEvent(CA_EVENT_TYPES.CONTACT_FORM_SUBMIT);
            await customerActionExposeContact(buildSendMailActionParams(data));
            triggerConfirmView();
        }
        catch (error) {
            setLoading(false);
            setPostLeadError(true);
        }
    };
    return { handleSubmit, loading, postLeadError };
};
